
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/[hotel_slug]",
      function () {
        return require("private-next-pages/hotels/[hotel_slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/[hotel_slug]"])
      });
    }
  